import React from 'react';
import { Card } from './ui/card';

const HowIWork = () => {
  const steps = [
    {
      number: '01',
      title: 'Start with diagnosis and clarity',
      description: 'Most marketing problems are strategy problems in disguise. I start by understanding the business, the customer, and what success actually looks like.',
    },
    {
      number: '02',
      title: 'Design the right strategy and systems',
      description: 'Strategy without systems is just a plan. I design repeatable frameworks—acquisition funnels, content engines, GTM playbooks—that scale.',
    },
    {
      number: '03',
      title: 'Apply AI where it creates leverage',
      description: 'AI is not magic. It is leverage. I use it to automate workflows, personalize at scale, and let small teams operate like large ones.',
    },
    {
      number: '04',
      title: 'Enable teams to execute with confidence',
      description: 'The best systems are ones people can run without you. I build clarity into processes, dashboards, and decision-making frameworks.',
    },
    {
      number: '05',
      title: 'Focus on measurable impact and long-term value',
      description: 'I track what matters: CAC, LTV, payback period, conversion rates, and revenue. Everything else is vanity.',
    },
  ];

  return (
    <section id="approach" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-900 mb-4">How I Work</h2>
        <p className="text-slate-600 mb-12 max-w-3xl">
          My approach is structured, thoughtful, and execution-aware. Here's what you can expect.
        </p>

        <div className="space-y-6">
          {steps.map((step, index) => (
            <Card key={index} className="p-6 border-slate-200">
              <div className="flex items-start gap-6">
                <div className="text-3xl font-bold text-slate-300 flex-shrink-0">{step.number}</div>
                <div>
                  <h3 className="text-lg font-semibold text-slate-900 mb-2">{step.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowIWork;